import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const inputVariants = cva(
  // gemeinsame Basis
  "block w-full rounded-md border px-3 py-2 placeholder:opacity-70",
  {
    variants: {
      intent: {
        default:
          // Light
          "border-slate-300 bg-white text-slate-900 placeholder-slate-400 " +
          // Dark
          "dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:placeholder-slate-500 " +
          // Focus
          "focus:outline-none focus:ring-2 focus:ring-hawkeye-600 focus:border-hawkeye-600",
        error:
          "border-red-500 focus:border-red-500 focus:ring-red-500 dark:border-red-400",
        disabled:
          "opacity-60 cursor-not-allowed dark:opacity-50 dark:bg-slate-800",
      },
      size: {
        sm: "h-9 text-sm",
        md: "h-11",
        lg: "h-12 text-lg",
      },
    },
    defaultVariants: { intent: "default", size: "md" },
  }
);

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size">,
    VariantProps<typeof inputVariants> {}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, intent, size, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(inputVariants({ intent, size }), className)}
      {...props}
    />
  )
);
Input.displayName = "Input";
